import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Mail, MessageSquare, UserCircle2, Globe, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

export default function Contact() {
  const [params] = useSearchParams();
  const topic = params.get("topic");
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (topic) setForm((f) => ({ ...f, message: `I'm interested in the ${topic} category. Please share details.` }));
  }, [topic]);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", { ...form, topic: topic || "GENERAL INQUIRY" });
      toast.success("Message received. The 10XGLOBAL team will respond within one business day.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 md:px-8 py-14 grid lg:grid-cols-2 gap-12" data-testid="contact-page">
      <div>
        <p className="gold-kicker mb-3">Contact</p>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-100">TALK TO THE NETWORK.</h1>
        <p className="mt-4 text-slate-400 leading-relaxed max-w-md">Membership questions, verification queries, enterprise partnerships or press — reach the right desk.</p>
        <div className="mt-10 space-y-5">
          <div className="card-surface hairline-gold p-5" data-testid="founder-contact-card">
            <p className="flex items-center gap-3 text-sm text-slate-200 font-semibold"><UserCircle2 size={16} className="text-gold" /> Rathod Anand Singh</p>
            <p className="ml-7 text-[10px] font-mono uppercase tracking-widest text-gold mt-1">Founder & CEO</p>
          </div>
          <p className="flex items-center gap-3 text-sm text-slate-300"><Mail size={16} className="text-gold" /> rathod@10x-global.com</p>
          <p className="flex items-center gap-3 text-sm text-slate-300"><Globe size={16} className="text-gold" /> 10x-global.com</p>
          <p className="flex items-center gap-3 text-sm text-slate-300"><MessageSquare size={16} className="text-gold" /> 10X AI is available 24/7 inside the platform</p>
        </div>
      </div>
      <form onSubmit={submit} className="card-surface p-7 space-y-5" data-testid="contact-form">
        <div>
          <label className="block text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-2">Name</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name-input" className="input-dark" placeholder="Your name" />
        </div>
        <div>
          <label className="block text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-2">Business Email</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email-input" className="input-dark" placeholder="you@company.com" />
        </div>
        <div>
          <label className="block text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-2">Message</label>
          <textarea rows={5} required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message-input" className="input-dark resize-none" placeholder="How can the network help your business?" />
        </div>
        <button type="submit" disabled={sending} data-testid="contact-submit-btn" className="btn-gold w-full disabled:opacity-60">
          {sending ? <><Loader2 size={15} className="animate-spin" /> SENDING…</> : "SEND MESSAGE"}
        </button>
      </form>
    </div>
  );
}
